import { Children } from 'react';
import type { PropsWithChildren, ReactElement } from 'react';

import styled from 'styled-components';

type AlignType = 'left' | 'right';
type IndentType = 'default' | 'small';

export const StyledWrapper = styled.div<{
  align: AlignType;
  indent: IndentType;
}>(
  ({
    align,
    indent,

    theme: { buttonToolbar },
  }) => ({
    marginRight: -(indent === 'small'
      ? buttonToolbar.MARGIN_RIGHT_SMALL
      : buttonToolbar.MARGIN_RIGHT_DEFAULT),
    marginBottom: -(indent === 'small'
      ? buttonToolbar.MARGIN_BOTTOM_SMALL
      : buttonToolbar.MARGIN_BOTTOM_DEFAULT),
    textAlign: align,
  }),
);

export const StyledButton = styled.div<{
  indent: 'default' | 'small';
}>(
  ({
    indent,

    theme: { buttonToolbar },
  }) => ({
    display: 'inline-block',
    verticalAlign: 'bottom',
    marginRight:
        indent === 'small'
          ? buttonToolbar.MARGIN_RIGHT_SMALL
          : buttonToolbar.MARGIN_RIGHT_DEFAULT,
    marginBottom:
        indent === 'small'
          ? buttonToolbar.MARGIN_BOTTOM_SMALL
          : buttonToolbar.MARGIN_BOTTOM_DEFAULT,
  }),
);

export type ButtonToolbarProps = PropsWithChildren<{
  /**
   * Выравнивание кнопок внутри
   */
  align?: AlignType;

  /**
   * Расстояние между кнопками
   */
  indent?: IndentType;
}>;

export function ButtonToolbar({
  align = 'left',
  indent = 'default',
  children = undefined,
}: ButtonToolbarProps): ReactElement {
  const childrenArray = Children.toArray(children);

  return (
    <StyledWrapper
      indent={indent}
      align={align}
    >
      {childrenArray.map((button, index) => (
        <StyledButton
          indent={indent}
          key={index}
        >
          {button}
        </StyledButton>
      ))}
    </StyledWrapper>
  );
}
